import Service from "~/services/service";
import {RouteHelper} from "~/helpers/routeHelper";

export default class EntryBulkActionProvider extends Service {
  // this is a single-action provider, so whatever
  create({listView}, data) {
    return new Promise((resolve, reject) => {
      const requestData = {
        _method: 'POST',
        authenticity_token: this.csrfToken()
      };

      // works whether listView is a ListView, or PublishedListView 🤯 🤮
      const nonPublishedListViewId = listView.list_view_id

      $.ajax({
        url: `/list_views/${nonPublishedListViewId}/bulk_action`,
        type: 'POST',
        dataType: 'json',
        data: Object.assign({}, data, requestData),
      }).done(function (result) {
        resolve(result);
      }).fail(function (result) {
        reject();
      });
    });
  }
}

